import { StreamActions } from "@hotwired/turbo"
import * as bootstrap from "bootstrap"

// Custom Turbo Stream action to close a Bootstrap modal
StreamActions.close_modal = function() {
  const modalId = this.getAttribute("target")
  const modalElement = document.getElementById(modalId)

  if (modalElement) {
    const modal = bootstrap.Modal.getInstance(modalElement)
    if (modal) {
      modal.hide()
    }
  }
}
